import { render, staticRenderFns } from "./rewardSerialCollectPackEdit_bak.vue?vue&type=template&id=f5f28e96&scoped=true&"
import script from "./rewardSerialCollectPackEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardSerialCollectPackEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f28e96",
  null
  
)

export default component.exports